export function syncFavicon(href) {
  if (typeof document === 'undefined') {
    return
  }

  const normalizedHref = href || '/favicon.ico'
  let link = document.querySelector('link[rel="icon"]')

  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'icon')
    document.head.appendChild(link)
  }

  link.setAttribute('href', normalizedHref)
}
